// CTA pós-resultado da calculadora → Douto.
// PRIVACIDADE: nada do cálculo (escore, escolaridade, respostas) entra na URL nem nos
// eventos de analytics — a Política de Privacidade promete isso. A URL leva apenas UTMs
// fixos e o texto do CTA não exibe números.

export const DOUTO_HANDOFF_URL = 'https://douto.app/minimental';
export const DOUTO_HANDOFF_PLACEMENT = 'calculator_result';
export const DOUTO_HANDOFF_HEADLINE = 'Calculou o MEEM? Perguntar ao Douto o que fazer com o resultado — Primeiro caso grátis + 7 dias de garantia';

export function handoffUrl() {
  const url = new URL(DOUTO_HANDOFF_URL);
  url.search = new URLSearchParams({
    utm_source: 'minimental',
    utm_medium: 'result',
    utm_campaign: 'meem_proximo_passo',
    utm_content: 'meem_resultado',
  }).toString();
  return url.toString();
}

export function deviceType() {
  if (typeof window === 'undefined' || !window.matchMedia) return 'unknown';
  if (window.matchMedia('(max-width: 767px)').matches) return 'mobile';
  if (window.matchMedia('(max-width: 1023px)').matches) return 'tablet';
  return 'desktop';
}

export function handoffEventProps(placement = DOUTO_HANDOFF_PLACEMENT) {
  return {
    placement,
    device: deviceType(),
    destination: 'douto.app',
    utm_source: 'minimental',
    utm_medium: 'result',
    utm_campaign: 'meem_proximo_passo',
    utm_content: 'meem_resultado',
  };
}

// CTA discreto dos guias → Douto (final do conteúdo, só onde o tema pede próximo passo clínico).
// Sem dados do cálculo: a URL leva apenas UTMs fixos.
export const GUIDE_DOUTO_PATHS = [
  '/interpretacao-dos-resultados',
  '/pontos-de-corte',
  '/acompanhamento-e-queda-de-pontos',
];

export function guideDoutoUrl() {
  const url = new URL(DOUTO_HANDOFF_URL);
  url.search = new URLSearchParams({
    utm_source: 'minimental',
    utm_medium: 'guide',
    utm_campaign: 'meem_proximo_passo',
    utm_content: 'meem_guia',
  }).toString();
  return url.toString();
}
